import CloseIcon from "@mui/icons-material/Close";
import { referralAmoutWithdraw } from "../../../ApiServices/ApiServices";
import { FaWallet, FaCheckCircle } from "react-icons/fa";
import { handleError } from "../../../Utils";
import { useState } from "react";
import { useAuth } from "../../../provider/authProvider";

const ReferralAmoutWithdrawRequest = ({
  setWithdrawRequestVisible,
  balanceToWithdraw,
  referralsDetails,
  fetchReferralRequestedAmount,
}) => {
  const [paymentInitiatedPopUp, setPaymentInitiatedPopUp] = useState(false);
  const [confirmatinMessage, setConfirmationMessage] = useState("");
  const { getUserName } = useAuth();
  const name = getUserName();
  const [loading, setLoading] = useState(false);

  const handleClosePopUps = async () => {
    setWithdrawRequestVisible(false);
    setPaymentInitiatedPopUp(!paymentInitiatedPopUp);
    // window.location.reload();
    await referralsDetails();
    await fetchReferralRequestedAmount();
  };

  const handleWithdrawRequest = async () => {
    try {
      setLoading(true);
      const response = await referralAmoutWithdraw(name);
      setConfirmationMessage(response.message);
      setPaymentInitiatedPopUp(!paymentInitiatedPopUp);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }finally{
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 ">
        <div className="bg-white rounded-lg w-full max-w-md p-6">
          <div className="flex">
            <div className="bg-green-200 p-4 rounded-l-lg w-1/3 flex items-center justify-center">
              <FaWallet className="text-white text-4xl" />
            </div>

            {/* Right Column */}
            <div className="p-4 w-2/3">
              <div
                className="close-icon"
                onClick={() => setWithdrawRequestVisible(false)}
              >
                <CloseIcon />
              </div>
              <div className="text-2xl text-gray-700 font-bold mb-2">
                Withdraw Earnings
              </div>
              <div className="text-sm text-gray-600 mb-4">
                The transaction will be done from{" "}
                <b className="font-semibold text-gray-700">
                  Codequeue Technologies
                </b>
                &nbsp; and will reflect in your bank account instantly.
              </div>

              {/* Amount Container */}
              <div className="border-dotted border-2 border-gray-300 p-4 mb-4 rounded-lg">
                <div className="flex justify-between text-gray-600">
                  <span className="text-sm">Amount</span>
                  <span className="text-sm">₹{balanceToWithdraw}</span>
                </div>
              </div>

              {/* Withdraw Button */}
              <button
                disabled={loading}
                className={`bg-black text-white font-bold py-2 px-6 rounded-lg w-full ${loading?'cursor-not-allowed':""}`}
                onClick={handleWithdrawRequest}
              >
                Confirm Withdraw
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Payment Initiated Confirmation Popup */}
      {paymentInitiatedPopUp && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-sm">
            <div className="text-center">
              <div className="flex items-center justify-center">
                <FaCheckCircle className="text-blue-500 text-5xl mb-4" />
              </div>

              <div className="text-lg text-gray-800 font-bold">
                {confirmatinMessage}
              </div>
              <div className="text-sm text-gray-600 mt-2">
                Funds are on the way to your account. In case of any issues,
                reach out at <br />
                <b>Support@codequeue.in</b>
              </div>
              <div className="mt-4">
                <button
                  onClick={handleClosePopUps}
                  className="bg-black text-white font-bold py-2 px-8 rounded-lg w-[200px]"
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReferralAmoutWithdrawRequest;
